import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createHashHistory'
import { composeWithDevTools } from 'redux-devtools-extension'
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import fieldsReducer from '../modules/fields/fields-reducer'
import errorsReducer from '../modules/errors/errors-reducer'
import configReducer from '../modules/config/config-reducer'
import navigationReducer from '../modules/navigation/navigation-reducer'
import productDataReducer from '../modules/product-data/product-data-reducer'
import statusReducer from '../modules/status/status-reducer'
import cobrandReducer from '../modules/cobrand/cobrand-reducer'
import formReducer from '../modules/form/form-reducer'
import PropTypes from 'prop-types'


export default function(reducers){
    
    const composeEnhancers = composeWithDevTools({
        // Specify name here, actionsBlacklist, actionsCreators and other options if needed
    });

    const middleware = applyMiddleware(
        thunk,
        routerMiddleware( createHistory() ),
    )

    const store = createStore(
        combineReducers( reducers ),
        {},
        composeEnhancers( middleware )
    )

    return store;
}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/setup/get-chu-form-store.ts